/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Status_FinalizingInputs */

const en_work_order_publish_status_finalizing = /** @type {(inputs: Work_Order_Publish_Status_FinalizingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishing complete. Finalizing publish workflow...`)
};

const fr_work_order_publish_status_finalizing = /** @type {(inputs: Work_Order_Publish_Status_FinalizingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publication terminée. Finalisation du flux de publication...`)
};

const de_work_order_publish_status_finalizing = /** @type {(inputs: Work_Order_Publish_Status_FinalizingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichung abgeschlossen. Veröffentlichungsprozess wird finalisiert...`)
};

const it_work_order_publish_status_finalizing = /** @type {(inputs: Work_Order_Publish_Status_FinalizingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblicazione completata. Finalizzazione del flusso di lavoro di pubblicazione in corso...`)
};

const ru_work_order_publish_status_finalizing = /** @type {(inputs: Work_Order_Publish_Status_FinalizingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Публикация завершена. Завершается настройка процесса публикации...`)
};

const es_work_order_publish_status_finalizing = /** @type {(inputs: Work_Order_Publish_Status_FinalizingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación completada. Finalizando el flujo de trabajo de publicación...`)
};

const zh_cn2_work_order_publish_status_finalizing = /** @type {(inputs: Work_Order_Publish_Status_FinalizingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布完成。正在完成发布工作流程……`)
};

const ja_work_order_publish_status_finalizing = /** @type {(inputs: Work_Order_Publish_Status_FinalizingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開が完了しました。公開ワークフローを最終処理しています...`)
};

const hi_work_order_publish_status_finalizing = /** @type {(inputs: Work_Order_Publish_Status_FinalizingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकाशन प्रक्रिया पूरी हो गई है। प्रकाशन कार्यप्रवाह को अंतिम रूप दिया जा रहा है...`)
};

const pt_pt2_work_order_publish_status_finalizing = /** @type {(inputs: Work_Order_Publish_Status_FinalizingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicação concluída. Finalizando o fluxo de trabalho de publicação...`)
};

/**
* | output |
* | --- |
* | "Publishing complete. Finalizing publish workflow..." |
*
* @param {Work_Order_Publish_Status_FinalizingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_status_finalizing = /** @type {((inputs?: Work_Order_Publish_Status_FinalizingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Status_FinalizingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_status_finalizing(inputs)
	if (locale === "de") return de_work_order_publish_status_finalizing(inputs)
	if (locale === "it") return it_work_order_publish_status_finalizing(inputs)
	if (locale === "ru") return ru_work_order_publish_status_finalizing(inputs)
	if (locale === "es") return es_work_order_publish_status_finalizing(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_status_finalizing(inputs)
	if (locale === "ja") return ja_work_order_publish_status_finalizing(inputs)
	if (locale === "hi") return hi_work_order_publish_status_finalizing(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_status_finalizing(inputs)
	return en_work_order_publish_status_finalizing(inputs)
});